import useSolrProduct from "./useSolrProduct";
import productSearchParamsBuilder, {getProductRequest} from "../../../logic/product/productSearchParams";
import FilterUrl from "../../../logic/filter/filterUrl";
import MapUtil from "../../../logic/collection/mapUtil";
import useValueChangeListener from "../general/useValueChangeListener";
import useSession from "../session/useSession";
import useRequestTracker from "../request/useRequestTracker";
import {useState} from "react";

const useProductIDPage = (pageNo, productIDs, filterParam, pageSize=20) => {

    const { sessionContext : session } = useSession();

    const {
        loading: initLoad,
        error: initError,
        sendIt
    } = useRequestTracker();

    const [ { productCount, availableIds }, setInfo ] = useState({});

    const {
        error,
        loading,
        products,
        getProducts,
    } = useSolrProduct();

    const init = () => {
        if(!productIDs || productIDs.length === 0) return;
        const productOrderMap = new Map(
            productIDs.map((id, index) => [id, index])
        );

        const builder = productSearchParamsBuilder()
            .pageSize(10000)
            .pageNo(1)
            .productIDs(productIDs);

        const filters = FilterUrl.getMap(filterParam);
        if(filters) {
            MapUtil.forEach(filters, (k, v) => {
                v.forEach(fv => builder.filterAttribute(k, fv))
            })
        }

        const req = getProductRequest(builder.getParams(), session?.priceListID);
        sendIt(req.sendRequest, (resp) => {
            const productCount = resp.count;
            const availableIds = resp.products?.map(p => p.id).sort(
                (a, b) => productOrderMap.get(a) - productOrderMap.get(b)
            );
            setInfo({ productCount, availableIds });
        });
    }

    const fetchPage = () => {
        if(!availableIds || availableIds.length === 0) return

        const offset = ((pageNo || 1) -1) * pageSize;

        const ids = availableIds.slice(offset, offset + pageSize);

        if(!ids || ids.length === 0) return;

        const builder = productSearchParamsBuilder()
            .pageSize(pageSize)
            .pageNo(1)
            .sortByID(true)
            .productIDs(ids);

        getProducts(builder.getParams());
    }


    useValueChangeListener(init, [productIDs, filterParam], []);
    useValueChangeListener(fetchPage, [pageNo, availableIds, pageSize], []);

    const pageCount = (Math.floor(productCount / pageSize)) + 1;

    return {
        loading: loading || initLoad,
        error: error || initError,
        products,
        pageCount
    }
}

export default useProductIDPage;
